import { ofType } from "redux-observable";
import { empty, of } from "rxjs";
import { concat } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { push } from "react-router-redux";
import { notification } from "antd";
import { pendingProgram, begin, end } from "react-redux-spinner";
import normalize from "json-api-normalizer";
import { parseError } from "./lib";

import ProgramService from "../services/programService";

import {
  savePatientProgramItemRequest,
  SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION,
  SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION
} from "../ducks/patient";

import {
  loadProgramsSuccess,
  loadProgramsFailure,
  LOAD_PROGRAMS_REQUEST_ACTION,
  SAVE_PROGRAM_REQUEST_ACTION,
  saveProgramFailure,
  saveProgramSuccess,
  DELETE_PROGRAM_REQUEST_ACTION,
  deleteProgramFailure,
  deleteProgramSuccess,
  LOAD_PROGRAM_REQUEST_ACTION,
  loadProgramSuccess,
  loadProgramFailure,
  SAVE_PROGRAM_ITEM_REQUEST_ACTION,
  saveProgramItemSuccess,
  saveProgramItemFailure,
  loadProgramRequest,
  SAVE_PROGRAM_SUCCESS_ACTION,
  SAVE_PROGRAM_FAILURE_ACTION,
  saveProgramRequest,
  DELETE_PROGRAM_ITEM_REQUEST_ACTION,
  deleteProgramItemSuccess,
  deleteProgramItemFailure,
  saveProgramItemRequest,
  SAVE_PROGRAM_ITEM_SUCCESS_ACTION,
  SAVE_PROGRAM_ITEM_FAILURE_ACTION,
  INSERT_PROGRAM_ITEM_REQUEST_ACTION,
  LOAD_PROGRAMS_FAILURE_ACTION,
  LOAD_PROGRAM_FAILURE_ACTION,
  DUPLICATE_PROGRAM_REQUEST_ACTION,
  duplicateProgramSuccess
} from "../ducks/data";
import {
  saveProgramFormSuccess,
  saveProgramFormFailure,
  SAVE_PROGRAM_FORM_REQUEST_ACTION
} from "../ducks/program";
import { setActiveDialog } from "../ducks/app";
import {
  saveProgramItemFormFailure,
  saveProgramItemFormSuccess,
  SAVE_PROGRAM_ITEM_FORM_REQUEST_ACTION
} from "../ducks/program_item";

const _ = require("lodash");
export const loadProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let programService = new ProgramService();
      return programService
        .find(action.payload)
        .then(response => {
          return loadProgramSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadProgramFailure(parseError(error));
        });
    })
  );
export const loadProgramFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PROGRAM_FAILURE_ACTION.getType()),
    mergeMap(action => {
      return of(push("/programs"));
    })
  );
export const loadProgramsEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_PROGRAMS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let programService = new ProgramService();
      return programService
        .findAll(action.payload)
        .then(response => {
          return loadProgramsSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadProgramsFailure(parseError(error));
        });
    })
  );

export const saveProgramFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROGRAM_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(saveProgramRequest(action.payload));
    })
  );

export const saveProgramFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROGRAM_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      var id = Object.keys(action.payload.program.programs)[0];
      return concat(
        of(saveProgramFormSuccess(action.payload.program)),
        of(push(`/programs/${id}`)),
        of(setActiveDialog())
      );
    })
  );

export const saveProgramFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROGRAM_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveProgramFormFailure(action.payload));
    })
  );

export const saveProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ProgramService();
      return service
        .save(action.payload)
        .then(response => {
          return saveProgramSuccess(normalize(response.data));
        })
        .catch(error => {
          return saveProgramFailure(parseError(error));
        });
    })
  );

export const deleteProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ProgramService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteProgramSuccess(action.payload);
          })
          .catch(error => {
            return deleteProgramFailure(error);
          }),
        of(setActiveDialog())
      );
    })
  );

export const duplicateProgramEpic = (action$, state$) =>
  action$.pipe(
    ofType(DUPLICATE_PROGRAM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ProgramService();
      return concat(
        service
          .duplicate(action.payload)
          .then(response => {
            return duplicateProgramSuccess(normalize(response.data));
          })
          .catch(error => {
            return duplicateProgramSuccess(error);
          }),
        of(setActiveDialog())
      );
    })
  );

export const saveProgramItemFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROGRAM_ITEM_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return action.payload.type === "programItems"
        ? of(saveProgramItemRequest(action.payload))
        : of(savePatientProgramItemRequest(action.payload));
    })
  );

export const saveProgramItemFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(
      SAVE_PROGRAM_ITEM_SUCCESS_ACTION.getType(),
      SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION.getType()
    ),
    mergeMap(action => {
      return concat(
        of(saveProgramItemFormSuccess(action.payload))
        // figure out if we're doing an update or an insert
        // for an update, don't need to reload everything...
        /*!action.payload.id
          ? of(loadProgramRequest(action.payload.attributes.programId))
          : empty()*/
      );
    })
  );

export const saveProgramItemFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(
      SAVE_PROGRAM_ITEM_FAILURE_ACTION.getType(),
      SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION.getType()
    ),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveProgramItemFormFailure(action.payload));
    })
  );

export const insertProgramItemEpic = (action$, state$) =>
  action$.pipe(
    ofType(INSERT_PROGRAM_ITEM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ProgramService();
      return concat(
        service
          .saveProgramItem(action.payload)
          .then(response => {
            return saveProgramItemSuccess(normalize(response.data));
          })
          .catch(error => {
            return saveProgramItemFailure(parseError(error));
          }),
        of(loadProgramRequest(action.payload.attributes.programId)),
        of(setActiveDialog())
      );
    })
  );

export const saveProgramItemEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PROGRAM_ITEM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ProgramService();
      return concat(
        service
          .saveProgramItem(action.payload)
          .then(response => {
            return saveProgramItemSuccess(normalize(response.data));
          })
          .catch(error => {
            return saveProgramItemFailure(parseError(error));
          })
      );
    })
  );

export const deleteProgramItemEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_PROGRAM_ITEM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ProgramService();
      return concat(
        service
          .archiveProgramItem(action.payload)
          .then(response => {
            return deleteProgramItemSuccess(action.payload);
          })
          .catch(error => {
            return deleteProgramItemFailure(parseError(error));
          }),
        of(loadProgramRequest(action.payload.attributes.programId)),
        of(setActiveDialog())
      );
    })
  );



// WEBPACK FOOTER //
// ./src/epics/programs.js